var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechImg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8808 10.5916C29.4998 11.0776 29.6076 11.9734 29.1216 12.5924C28.6356 13.2114 27.7398 13.3192 27.1208 12.8332C26.5018 12.3472 26.394 11.4514 26.88 10.8324C27.3661 10.2134 28.2619 10.1056 28.8808 10.5916ZM19.1216 18.5924C19.6076 17.9734 19.4998 17.0776 18.8808 16.5916C18.2619 16.1056 17.3661 16.2134 16.88 16.8324C16.394 17.4514 16.5018 18.3472 17.1208 18.8332C17.7398 19.3192 18.6356 19.2114 19.1216 18.5924ZM29.15 41.711H26.85V17.711H29.15V41.711ZM19.15 25.711V41.711H16.85V25.711H19.15ZM9.15 29.711V41.711H6.85V29.711H9.15ZM4.15 41.711V34.211H1.85V41.711H4.15ZM1 45.861H30V43.561H1V45.861ZM14.15 41.711V31.711H11.85V41.711H14.15ZM24.15 41.711V27.711H21.85V41.711H24.15ZM8.88085 19.5916C9.49984 20.0776 9.60764 20.9734 9.12161 21.5924C8.63559 22.2114 7.73979 22.3192 7.12079 21.8332C6.5018 21.3472 6.394 20.4514 6.88003 19.8324C7.36606 19.2134 8.26185 19.1056 8.88085 19.5916Z",
    fill: "#4E66FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechImg3);
export default __webpack_public_path__ + "static/media/tech-img-3.31c6a033c92ed419518e2b265d6352fe.svg";
export { ForwardRef as ReactComponent };